export default __webpack_public_path__ + "spring_pull.png";